import React, { Component } from 'react';
import { connect } from 'react-redux';

class CreditHistory extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    let oCustomer      = this.props.customer ? this.props.customer : null;
    let aCreditRecords = "You do not have any credit history.";
    let sCreditHeader  = '';
    let sCreditIcon    = '';

    const iconCreditPurchase = (
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20px" height="20px"
      viewBox="0 0 20 20" enable-background="new 0 0 20 20" >
        <path
          fill="#7eaf44"
          d="M7.886,7.156c0,0.669,0.303,1.084,1.53,1.483V5.817C8.396,5.912,7.886,6.454,7.886,7.156z M10.676,10.855v2.901
          c1.021-0.111,1.579-0.621,1.579-1.387C12.255,11.668,11.903,11.237,10.676,10.855z M10,0C4.478,0,0,4.477,0,10
          c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10C20,4.477,15.523,0,10,0z M10.739,15.367v0.957c0,0.383-0.303,0.686-0.686,0.686
          s-0.701-0.303-0.701-0.686v-0.988c-1.196-0.128-2.296-0.558-3.27-1.244c-0.271-0.175-0.43-0.43-0.43-0.765
          c0-0.495,0.383-0.878,0.877-0.878c0.191,0,0.383,0.064,0.526,0.176c0.749,0.542,1.483,0.909,2.359,1.068v-3.141
          C7.088,9.946,6.004,9.069,6.004,7.268c0-1.706,1.354-2.886,3.349-3.045V3.887c0-0.382,0.318-0.686,0.701-0.686
          s0.686,0.303,0.686,0.686v0.351c0.941,0.111,1.738,0.414,2.472,0.876c0.255,0.144,0.479,0.383,0.479,0.765
          c0,0.495-0.398,0.877-0.893,0.877c-0.159,0-0.319-0.048-0.479-0.144c-0.557-0.335-1.1-0.574-1.642-0.702v3.062
          c2.424,0.606,3.46,1.579,3.46,3.285C14.136,14.012,12.764,15.177,10.739,15.367z"
        />
      </svg>
    );
    const iconCreditUsed = (
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
      viewBox="0 0 20 20" enable-background="new 0 0 20 20" >
        <path
          fill="#1c8ca8"
          d="M8.174,8.108c-0.827,0.077-1.24,0.517-1.24,1.086c0,0.543,0.245,0.879,1.24,1.203V8.108z M10.477,13.423
          c0-0.567-0.287-0.92-1.281-1.229v2.354C10.023,14.456,10.477,14.042,10.477,13.423z M4.091,0C3.094,0,1.649,0.5,1.649,2.547
          v15.641c0,0.998,0.855,1.812,1.9,1.812h11.768V3.19H4.27c-1.271,0-1.267-1.868,0-1.868h12.662v17.184h1.42V0H4.091z"
        />
      </svg>
    );
    const iconBonusCredit = (
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20">
        <path
          fill="#f6c607"
          d="M17.268,5.532h-3.891c1.234-0.123,1.626-0.36,1.777-0.456c0.623-0.391,1.056-1,1.219-1.715
          c0.164-0.716,0.039-1.453-0.352-2.073C15.516,0.481,14.646,0,13.691,0c-0.516,0-1.021,0.145-1.459,0.421
          C11.43,0.925,10.541,2.642,10,3.821c-0.541-1.179-1.43-2.896-2.232-3.4C7.328,0.145,6.824,0,6.308,0
          c-0.952,0-1.823,0.481-2.33,1.287C3.587,1.908,3.463,2.645,3.626,3.36C3.79,4.076,4.222,4.685,4.844,5.076
          c0.153,0.096,0.543,0.333,1.778,0.456H2.733c-0.68,0-1.233,0.552-1.233,1.235v3.218c0,0.524,0.375,1.145,1.066,1.145v7.638
          C2.566,19.445,3.149,20,3.869,20H16.13c0.72,0,1.304-0.555,1.304-1.234v-7.637c0.566,0,1.066-0.62,1.066-1.145V6.767
          C18.5,6.084,17.947,5.532,17.268,5.532z M12.76,1.26c0.801-0.502,1.924-0.24,2.424,0.554c0.248,0.397,0.328,0.868,0.225,1.326
          s-0.381,0.847-0.778,1.097c-0.183,0.115-0.845,0.382-3.024,0.382c-0.322,0-0.621-0.006-0.869-0.013
          C11.314,3.297,12.191,1.617,12.76,1.26z M5.37,4.236C4.974,3.987,4.697,3.597,4.593,3.14C4.488,2.682,4.567,2.211,4.817,1.814
          c0.323-0.516,0.881-0.823,1.49-0.823c0.329,0,0.652,0.093,0.933,0.269c0.567,0.357,1.445,2.037,2.024,3.345
          C9.017,4.612,8.719,4.618,8.396,4.618C6.215,4.618,5.554,4.351,5.37,4.236z"/>
      </svg>
    );
    const iconSkippedCredit = (
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20">
        <path
        fill="#cf2041"
        d="M3.708,20c0,0-0.029-3.357,0-5.522c0.051-3.895,1.321-7.33,9.266-7.33V10.6L20,5.302L12.974,0v3.457
          c-10.1,0-12.876,4.46-12.962,10.958c-0.026,1.978,0,5.585,0,5.585H3.708z"/>
      </svg>
    );
    const iconSyncCredit = (
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20">
        <polygon points="0,5.305 7.07,10.61 7.07,7.152 20,7.152 20,3.458 7.07,3.458 7.07,0  "/>
        <polygon points="12.927,9.39 12.927,12.849 0,12.849 0,16.542 12.927,16.542 12.927,20 20,14.695  "/>
      </svg>
    );

    if (oCustomer && this.props.isLoggedIn && oCustomer.credit_history && oCustomer.credit_history.length > 0) {
      aCreditRecords = oCustomer.credit_history.map(( oCredit, i )=> {

        let sNumbertoShow = Math.abs(oCredit.balance_change);
        if (sNumbertoShow === 0){ sNumbertoShow = ''}

        switch(oCredit.action_label){
          case 'active_accept':
            sCreditHeader = 'Credits Purchased';
            sCreditIcon   = iconCreditPurchase;
            break;
          case 'passive_accept':
            sCreditHeader = 'Credits Purchased';
            sCreditIcon   = iconCreditPurchase;
            break;
          case 'active_decline':
            sCreditHeader = 'Credits Skipped';
            sCreditIcon   = iconSkippedCredit;
            break;
          case 'order_usage':
            sCreditHeader = 'Credits Used';
            sCreditIcon   = iconCreditUsed;
            break;
          case 'bonus_credit':
            sCreditHeader = 'Bonus Credits';
            sCreditIcon   = iconBonusCredit;
            break;
          default:
            sCreditHeader = 'Other';
        }
        return (
          <li key={i}>
            <ul>
              <li className="credit-order-header">
                <div className={ 'half-col ' + sCreditHeader}>
                  {sCreditIcon}
                  <span>{sNumbertoShow}&nbsp;{sCreditHeader}</span>
                </div>
                <div className="half-col text-right">
                  <span>{oCredit.created_at}</span>
                </div>
              </li>
            </ul>
          </li>
        );
      });
    }

    return (
      <div className="credits-list">
        <h4 className="alt2">Credits History</h4>
        <ul className="order-history-list">
          {aCreditRecords}
        </ul>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'isLoggedIn': state.isLoggedIn
    };
}

export default connect(mapStateToProps)(CreditHistory);


// WEBPACK FOOTER //
// ./src/components/CreditHistory.jsx